import { createContext, useContext } from "react";

import type { DocumentViewportValue } from "@/features/document-viewport/types";

export const DocumentViewportContext = createContext<DocumentViewportValue | null>(null);

export function useDocumentViewport() {
  const value = useContext(DocumentViewportContext);
  if (!value) {
    throw new Error("useDocumentViewport must be used within a DocumentViewportHost");
  }
  return value;
}
